import { Control } from "ol/control";

/**
 * 地図レイヤ切替ボタン定義クラス
 */
export class CaptureFrame extends Control {
  /**
   * コンストラクタ
   */
  constructor(rectWidth: number, rectHeight: number) {
    const element = document.createElement("div");
    element.id = "captureFrame";
    element.setAttribute("data-html2canvas-ignore", "true");
    element.className = "capture-frame-control";
    element.style.border = "2px solid red";
    element.style.zIndex = "999";
    element.style.left = "50%";
    element.style.top = "50%";
    element.style.display = "flex";
    element.style.pointerEvents = "none";
    element.style.position = "absolute";
    element.style.transform = "translate(-50%,-50%)";

    super({
      element: element,
    });
    this.setSize(rectWidth, rectHeight);
  }

  setSize(rectWidth: number, rectHeight: number) {
    const map = document.getElementById("map");
    const mapWidth = map.clientWidth;
    const mapHeight = map.clientHeight;
    let rate = 1;
    if (mapWidth / rectWidth <= mapHeight / rectHeight) {
      rate = (mapWidth - 80) / rectWidth;
    } else {
      rate = (mapHeight - 80) / rectHeight;
    }
    rectWidth = rectWidth * rate;
    rectHeight = rectHeight * rate;
    this.element.style.width = rectWidth.toFixed(0) + "px";
    this.element.style.height = rectHeight.toFixed(0) + "px";
  }
}
